import React, { useMemo } from 'react';

interface SeparatorWithTextProps {
	text?: string;
	className?: string;
	textColor?: string;
	bgColor?: string;
}

const SeparatorWithText: React.FC<SeparatorWithTextProps> = ({
	text,
	className = '',
	textColor,
	bgColor,
}) => {
	const seperator = useMemo(
		() => <div className={`h-px flex-grow`} style={{ backgroundColor: bgColor || '#D9D9D9' }} />,
		[bgColor]
	);

	return (
		<div className={`flex w-full items-center ${className}`}>
			{seperator}
			{text ? (
				<span className={`px-3 text-sm font-medium`} style={{ color: textColor || '#D1D5DB' }}>
					{text}
				</span>
			) : null}
			{seperator}
		</div>
	);
};

export default SeparatorWithText;
